// 集合列表页js
(function () {
  var currentSymbol =  LS.site.symbol;
  var filterData = null;
  var collectionPageParams = {};
  var curCollctionId = $('#collection-conatiner').attr('collectionId');
  // 上报参数
  var reportData = '';
  // sort下拉框html
  var sortDropdownhtml = `
    <% for ( var item of data ) { %>
      <div class="ls-options-li" data-value="<%= item.value %>">
        <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-collection-filter-active.png?v=1657259594" />
        <p class="li-value"><%= item.name %></p>
      </div>
    <% } %>
  `;
  var filterPopHtml = `
    <div class="ls-collection-filter-group">
      <div class="filter-group-clear-btn">Clear
          <span class="filter-item-num"></span>
      </div>
      <% if (data.sizeList.length > 0) { %>
        <div class="filter-group-item-box" type="Size">
          <p class="p-title">Size</p>
          <div class="group-item-box-ul">
            <% for ( var sizeItem of data.sizeList ) { %>
              <div class="box-li" data-type="size" data-value="<%= sizeItem %>"><%= sizeItem %></div>
            <% } %>
          </div>
        </div>
      <% } %>
      <% if (data.colorList.length > 0) { %>
        <div class="filter-group-item-box" type="Color">
          <p class="p-title">Color</p>
          <div class="group-item-color-ul">
            <% for ( var colorItem of data.colorList ) { %>
              <div class="box-li color-li"
                dara-color="<%= colorItem.color.indexOf('cdn.shopify') >= 0 ? ' #3E3737' : colorItem.color %>"
                data-type="color" data-value="<%= colorItem.value %>"
              >
                <div class="color-li-box">
                  <% if (colorItem.color.indexOf('cdn.shopify') >= 0) { %>
                    <img class="center-box-image"
                      src="<%= colorItem.color %>"
                      loading="lazy" />
                  <% } else { %>
                    <div class="center-box"
                      style="background: <%= colorItem.color %>;"
                    ></div>
                  <% } %>  
                </div>
                <p class="color-li-p"><%= colorItem.value %></p>
              </div>
            <% } %>
          </div>
        </div>
      <% } %>
      <% if (data.priceList.length > 0) { %>
        <div class="filter-group-item-box" type="Price">
          <p class="p-title">Price</p>
          <div class="group-item-box-ul">
            <% for ( var priceItem of data.priceList ) { %>
              <div class="box-li" data-type="price" min="<%= priceItem.startPrice %>" max="<%= priceItem.endPrice %>"><%= priceItem.label %></div>
            <% } %>
          </div>
        </div>
      <% } %>
    </div>
  `;


  // 底部单图片模块区域
  var bottomSingleImgHtml = `
    <div class="bottom-model-box">
      <p class="box-title"><%= data.title %></p>
      <div class="box-img-only">
        <% for ( var item of data.pcBanner ) { %>
          <a class="img-link" <% if (item.directUrl) { %>href="${LS.site.dir}<%= item.directUrl %>"<% } %>>
            <div class="img-box js-lazyload-img">
              <img src="<%= item.imgUrl %>" />
            </div>
          </a>
        <% } %>
      </div>
    </div>
  `;

  // 底部多图片模块区域
  var bottomMoreImgHtml = `
    <div class="bottom-model-box">
      <div class="box-title-top">
        <p class="box-title"><%= data.title %></p>
        <div class="box-change">
          <div class="change-icon left-icon">
            <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-index-list-lefticon.png?v=1658142443" />
          </div>
          <div class="change-icon right-icon">
            <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-index-list-righticon.png?v=1658142443" />
          </div>
        </div>
      </div>
      <div class="box-img-list">
        <% for ( var item of data.pcBanner ) { %>
          <a class="img-link" <% if (item.directUrl) { %>href="${LS.site.dir}<%= item.directUrl %>"<% } %>>
            <div class="img-box js-lazyload-img">
              <img src="<%= item.imgUrl %>" />
            </div>
          </a>
        <% } %>
      </div>
    </div>
  `;

  // 底部集合模块区域
  var bottomCollectionProductHtml = `
    <div class="bottom-model-box ls-featured-collection-sliderbox" data-key="history-product-module">
      <div class="ls-featured-collection-container">
        <div class="ls-featured-collection-con-title">
          <p class="ls-title-center"><%= data.title %></p>
          <div class="ls-list-changebox">
            <div class="ls-left-icon ls-left-icon-history-product-module">
              <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-index-list-lefticon.png?v=1658142443" />
            </div>
            <div class="ls-num-box"><p class="num1">0</p>/<p class="num2">0</p></div>
            <div class="ls-right-icon ls-right-icon-history-product-module">
              <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-index-list-righticon.png?v=1658142443" />
            </div>
          </div>
        </div>
        <div class="collection-listbox ls-featured-collection-listing" data-title="<%= data.collectionName %>">
          <div class="ls-featured-collection-product-list ls-product-list-row-4" data-list-type="<%= data.listType %>"></div>
        </div>
      </div>
    </div>
  `;

  // 集合列表方法
  var collectionPageFn = {
    handleReloadByFilter: function() {
      var activeFilters = $('.box-li-active');
        collectionPageParams =  LS.getData('collectionPageParams') || {};
        var colors = [];
        var priceRange = [];
        var sizes = [];
        if (activeFilters.length) {
          $('.filter-group-clear-btn').show();
          for(var i = 0, len = activeFilters.length; i < len; i++) {
            var filterItem = $(activeFilters[i]);
            var filterType = filterItem.attr('data-type');
            if (filterType === 'price') {
              var startPrice = filterItem.attr('min');
              var endPrice = filterItem.attr('max');
              priceRange = [{ currency: currentSymbol, startPrice: startPrice, endPrice: endPrice}];
            } else {
              var filterVal = filterItem.attr('data-value');
              if (filterType === 'color') {
                colors.push(filterVal);
              } else if (filterType === 'size') {
                sizes.push(filterVal);
              }
            }
          }
        } else {
          $('.filter-group-clear-btn').hide();
        }
        collectionPageParams.colors = colors;
        collectionPageParams.priceRange = priceRange;
        collectionPageParams.sizes = sizes;
        LS.setData('collectionPageParams', collectionPageParams);
        LS.ui.collectionFn.getCollectionPageList(true);
    },
    handleFilterData: function() {
      LS.ajax({
        url: LS.ui.routes.getCollectionFilter,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          collectionId: curCollctionId
        }),
        success: function (res) {
          if (res.hasError || res.code !== '0') {
            return;
          };
          var data = res.data;
          var colorList = data.colors || [];
          var sizeList = data.sizeList || [];
          var priceList = data.priceRangeList || [];
          var sortList = data.orders || [];
          priceList = priceList.map(item => {
            var label = '';
            if (!item.startPrice) {
              label = `<${item.currency}${item.endPrice}`;
            } else if (!item.endPrice) {
              label = `>${item.currency}${item.startPrice}`;
            } else {
              label = `${currentSymbol}${item.startPrice}-${currentSymbol}${item.endPrice}`;
            }
            return {
              startPrice: item.startPrice,
              endPrice: item.endPrice,
              label: label
            }
          });
          filterData = {
            sizeList: sizeList,
            colorList: colorList,
            priceList: priceList,
            sortList: sortList
          }
          var filterPopupHtmlStr = LS.tmpl(filterPopHtml, filterData);
          $('#ls-collection-filter-container').append(filterPopupHtmlStr)

          var sortHtmlStr = LS.tmpl(sortDropdownhtml, filterData.sortList);
          $('#ls-sort-dropdown-options').append(sortHtmlStr);
        },
        error: function (error) {
        },
      });
    },
    /**
     * 处理颜色的选项的方法
     */
    handleColor: function() {
      // 获取集合有的颜色数据
      var haveColorList = $('.js-filter-color-json').html().split(',');
      // 遍历更改数据
      for ( var i = 0; i < haveColorList.length; i++ ) {
        for ( var j = 0; j < colorList.length; j++ ) {
          for ( var m = 0; m < colorList[j].list.length; m++ ) {
            // 判断是否匹配
            if (colorList[j].list[m] === haveColorList[i]) {
              // 修改参数
              colorList[j].isShow = true;
            }
          }
        }
      }
      // -----插入内容-----
      // 创建数据html
      var htmlStr = LS.tmpl(colorFilterHtml, colorList);
      // 添加到页面
      $(".filter-group-item-color").html(htmlStr);
      // -----获取筛选数量数-----
      var filterNum = $('.ls-collection-filter-group').find('.box-li-active').length;
      // 赋值
      $('.ls-collection-filter-group .filter-item-num').html(`(${filterNum})`)
    },

    /**
     * 事件集合方法
     */
    bindEvent: function () {
      // 点击展开sort下拉框
      $(document).on('click', '.ls-sort-dropdown-box', function() {
        // 添加样式
        var status = JSON.parse($(this).attr('status')) || '';
        $(this).attr('status', !status);
        // 展开菜单
        if (status) {
          $('#ls-sort-dropdown-options').attr('style', 'height: 0px;opacity: 0;overflow: hidden;');
          $(this).find('.ls-dropdown-button-icon').attr('style', 'transform: rotate(0deg);');
        } else {
          $('#ls-sort-dropdown-options').attr('style', 'height: auto;opacity: 1;overflow: initial;');
          $(this).find('.ls-dropdown-button-icon').attr('style', 'transform: rotate(180deg);');
        }
      });

      // 点击sort选项
      $(document).on('click', '#ls-sort-dropdown-options .ls-options-li', function() {
        var activeCls = 'ls-options-li-active';
        var sortDropdownBox = $('.ls-sort-dropdown-box');
        var activeText = $(this).find('.li-value').text();
        collectionPageParams = LS.getData('collectionPageParams') || {};
        collectionPageParams.orderBy = $(this).attr('data-value');
        LS.setData('collectionPageParams', collectionPageParams);
        LS.ui.collectionFn.getCollectionPageList(true);
        $(this).addClass(activeCls).siblings().removeClass(activeCls);
        sortDropdownBox.find('.ls-drop-active').text(activeText);
        sortDropdownBox.attr('status', false);
        sortDropdownBox.find('.ls-dropdown-button-icon').attr('style', 'transform: rotate(0deg);');
        $('#ls-sort-dropdown-options').attr('style', 'height: 0px;opacity: 0;overflow: hidden;');
      });

      $(document).on('click', '.filter-group-clear-btn', function() {
        collectionPageParams =  LS.getData('collectionPageParams') || {};
        var activeFilters = $('.box-li-active');
        if (activeFilters.length) {
          for(var i = 0, len = activeFilters.length; i < len; i++) {
            var filterItem = $(activeFilters[i]);
            var filterType = filterItem.attr('data-type');
            filterItem.removeClass('box-li-active');
            if (filterType === 'color') {
              filterItem.find('.color-li-box').attr('style', `border: 2px solid #fff`)
            }
          }
        }
        $('.ls-collection-filter-group .filter-item-num').html('');
        collectionPageParams.colors = [];
        collectionPageParams.priceRange = [];
        collectionPageParams.sizes = [];
        collectionPageFn.handleReloadByFilter();
      });

      // 点击筛选选项
      $(document).on('click', '.filter-group-item-box .box-li', function() {
        var model = $(this).parents('.filter-group-item-box').attr('type');
        var activeCls = 'box-li-active';
        if ( $(this).hasClass(activeCls) ) {
          $(this).removeClass(activeCls);
          model == 'Color' && $(this).find('.color-li-box').attr('style', `border: 2px solid #fff`);
        } else {
          if (model == 'Price') {
            $(this).addClass(activeCls).siblings().removeClass(activeCls)
          } else {
            $(this).addClass(activeCls);;
            var colorValue = $(this).attr('dara-color');
            model == 'Color' && $(this).find('.color-li-box').attr('style', `border: 2px solid ${colorValue}`)
          }
        }
        var filterNum = $('.ls-collection-filter-group').find('.box-li-active').length;
        $('.ls-collection-filter-group .filter-item-num').html(`(${filterNum})`);

        collectionPageFn.handleReloadByFilter();
      });

      // 集合底部banner（单图）点击
      $(document).on('click', '.ls-main-collection-bottom-model .box-img-only .img-link', function() {
        var href = $(this).attr('href');
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.collectionReportMap['clickBottomBannerCollection'],
          ext2: JSON.stringify(reportData || []),
          ext4: href,
        });
      });

      // 集合底部picture(多图）点击
      $(document).on('click', '.ls-main-collection-bottom-model .box-img-list .img-link', function() {
        var index = $(this).index();
        var href = $(this).attr('href');
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.collectionReportMap['clickBottomPictureCollection'],
          ext2: JSON.stringify(reportData || []),
          ext3: `pos=${index+1}`,
          ext4: href,
        });
      });

      // 集合底部Recently Viewed模块商品点击
      $(document).on('click', '.ls-main-collection-bottom-model .ls-product-link', function() {
        // 判断
        if ($(this).parents('.box-recently-viewed').length > 0) {
          var reportType = LS.ui.collectionReportMap['clickRecentlyViewedProductCollection'];
        } else {
          var reportType = LS.ui.collectionReportMap['clickBottomProductCollection'];
        }
        // pos
        var index = $(this).parents('.ls-product-block').attr('stat-index');
        var curProductBlock = $(this).parents('.ls-product-block');
        // 商品信息
        // 处理sku里面的颜色
        var itemSku = curProductBlock.attr('stat-module-show-color');
        var itemCurSku = curProductBlock.attr('stat-module-show-selected-color');
        var color = itemCurSku != undefined && itemCurSku != 'undefined' ? itemCurSku.split('-')[1] : itemSku.split('-')[1];
        var param = {
          "products": {
            id: curProductBlock.attr('stat-module-show-id') + '',
            title: curProductBlock.attr('stat-module-show-title'),
            price: curProductBlock.attr('stat-module-show-price')/100,
            color: color,
          }
        };
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: reportType,
          ext2: JSON.stringify(param || []),
          ext3: `pos=${index}`,
          ext4: JSON.stringify(reportData || [])
        });
      });
    },

    /**
     * 多图模块切换
     */
    imgListModelScroll: function (dom) {
      // 获取图片数组的长度
      var imgLength = $(dom).find('.img-link').length;
      // 图片宽度
      var imgWidth = $(dom).width();
      // 当前位置
      var index = 1;
      // 页数
      var pageNum = Math.ceil(imgLength/4);

      // 点击left
      $(document).on("click", ".ls-main-collection-bottom-model .box-change .left-icon", function () {
        if (index > 1) {
          index--;
          // 移动
          $(dom).css('margin-left', `-${imgWidth*(index-1)}px`);
        }
      })

      // 点击right
      $(document).on("click", ".ls-main-collection-bottom-model .box-change .right-icon", function () {
        if (index < pageNum) {
          index++;
          // 移动
          $(dom).css('margin-left', `-${imgWidth*(index-1)}px`);
        }
      })
    },

    /**
     * 上报方法
     */
    reportHandle: function (reportType, ext1, data = {}) {
      // 上报
      LS.stat({
        eid: reportType,
        ext1: ext1,
        ...data
      });
    },

    /**
     * 创建集合页顶部介绍内容区域
     */
    createTopModelHandle: function () {
      var collectionTopModuleDomMobile = $('.collction-top-module_mobile');
      if (collectionTopModuleDomMobile.length) {
        collectionTopModuleDomMobile.remove();
      }
      if ($('.collction-top-module_pc').length) {
        $('.collction-top-module_pc').show();
        // 初始化header交互效果
        LS.ui.initHeaderInteractive();
        // 监听集合页顶部banner曝光
        var dom = document.querySelector('.ls-main-collection-top-model .top-model-image-box');
        LS.ui.globalModelShowHandle(dom, LS.ui.collectionReportMap['showTopBannerCollection'], {ext2: JSON.stringify(reportData || [])});
      }
      // 判断是否有文案
      if ($('.top-model-text-box').length) {
        // 监听集合页顶部集合描述曝光
        var dom = document.querySelector('.top-model-text-box');
        LS.ui.globalModelShowHandle(dom, LS.ui.collectionReportMap['showTopTextCollection'], {ext2: JSON.stringify(reportData || [])});
      }
    },

    /**
     * 创建集合页底部配置区域
     */
    createfooterModelHandle: function () {
      // 获取集合id
      var collectionId = $('.looksky-main-collection-modelbox').attr('collectionid');
      // 接口参数
      var params = JSON.stringify({
        collectionId: collectionId,
      })
      // 接口
      LS.ajax({
        url: LS.ui.routes.listBannerByCollectionId,
        type: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        data: params,
        success: function (res) {
          // 判断是否成功
          if (!res.hasError && res.code === "0" && res.data && res.data.length > 0 ) {
            // 定义数据
            var data = res.data[0];
            var bottomCollectionId = data.collectionId;
            // 判断数据展示不同模块内容
            if (data.pcBanner.length === 1) {
              // 插入模块
              var htmlStr = LS.tmpl(bottomSingleImgHtml, data);
              $('.ls-main-collection-bottom-model').append(htmlStr);
              // 集合底部banner（单图）曝光
              var dom = document.querySelector('.ls-main-collection-bottom-model .box-img-only');
              LS.ui.globalModelShowHandle(dom, LS.ui.collectionReportMap['showBottomBannerCollection'], {ext2: JSON.stringify(reportData || [])});
            } else if (data.pcBanner.length > 1) {
              // 插入模块
              var htmlStr = LS.tmpl(bottomMoreImgHtml, data);
              $('.ls-main-collection-bottom-model').append(htmlStr);
              // 多图模块切换
              collectionPageFn.imgListModelScroll($('.ls-main-collection-bottom-model .box-img-list'))
              // 集合底部banner（多图）曝光
              var obTargets = $('.ls-main-collection-bottom-model .box-img-list .img-link');
              // 开始观察
              try {
                obTargets && obTargets.length > 0 && obTargets.forEach((item, index) => {
                  LS.ui.globalModelShowHandle(item, LS.ui.collectionReportMap['showBottomPictureCollection'], {ext2: JSON.stringify(reportData || []), ext3: `pos=${$(item).index()+1}`});
                })
              } catch (e) {
              }
            }
            // 商品集合
            if (bottomCollectionId && data.collectionName) {
              // 插入模块
              data.listType = 'bottom_collection';
              var htmlStr = LS.tmpl(bottomCollectionProductHtml, data);
              $('.ls-main-collection-bottom-model').append(htmlStr);
              $('.ls-main-collection-bottom-model .bottom-model-box').addClass('box-collection-list');
              var collectionModel = $('.ls-main-collection-bottom-model').find(".ls-featured-collection-listing");
              LS.ui.collectionFn.getCollectionModule && LS.ui.collectionFn.getCollectionModule({
                dom: collectionModel, 
                collectionId: bottomCollectionId, 
                pageSize: 50,
                reset: true
              });
              // 集合底部列表模块曝光
              var dom = document.querySelector('.ls-main-collection-bottom-model .box-collection-list');
              LS.ui.globalModelShowHandle(dom, LS.ui.collectionReportMap['showBottomCollectionCollection'], {ext2: JSON.stringify(reportData || [])});
              // 判断当有图片模块时，不显示集合模块标题
              if (data.pcBanner.length > 0) {
                $('.box-collection-list .ls-featured-collection-container .ls-title-center').text('');
              }
            }
            if (data.pcBanner.length === 0 && !data.collectionName) {
              // 调用插入历史预览商品方法
              collectionPageFn.insertHistoryProductHandle();
            }
          } else {
            // 调用插入历史预览商品方法
            collectionPageFn.insertHistoryProductHandle();
          }
        },
        error: function (error) {
          // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
        complete: function() {
        }
      });
    },

    /**
     * 调用插入历史预览商品方法
     */
    insertHistoryProductHandle: function () {
      // 获取用户历史预览数据
      var productIdList = LS.cookie.get('graecove_productid_history');
      if (productIdList && productIdList.split(',').length > 0) {
        // 插入模块
        var data = {
          title: LS.$t('collection.recently_viewed_title'),
          collectionName: LS.$t('collection.recently_viewed_title'),
        }
        data.listType = 'recently_viewed';
        var htmlStr = LS.tmpl(bottomCollectionProductHtml, data);
        $('.ls-main-collection-bottom-model').append(htmlStr);
        $('.ls-main-collection-bottom-model .bottom-model-box').addClass('box-recently-viewed');
        // 调用查看历史预览商品接口
        var idList = productIdList.split(',');
        collectionPageFn.getHistoryProductRecordList(idList);
      }
    },

    /**
     * 调用查看历史预览商品接口
     */
    getHistoryProductRecordList: function (idList) {
      // 接口参数
      var params = JSON.stringify({
        productIdList: idList,
        version: 1
      })
      // 接口
      LS.ajax({
        url: LS.ui.routes.productQueryProductList,
        type: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        data: params,
        success: function (res) {
          // 判断是否成功
          if (!res.hasError && res.code === "0" && res.data && res.data.length > 0 ) {
            // ----Recently Viewed区域-----
            // 渲染dom
            var data = {
              record: res.data,
            };
            // 添加国家code码
            LS.ui.collectionFn.handleCollectionData && LS.ui.collectionFn.handleCollectionData(data.record);
            var recentlyViewedHtmlStr = LS.tmpl(LS.ui.productBlockDom, data);
            // 添加到集合页底部
            if (recentlyViewedHtmlStr) {
              $(".ls-main-collection-bottom-model .ls-featured-collection-product-list").append(recentlyViewedHtmlStr);
              // collection模块切换功能
              LS.ui.homePageFn.homeFeatureCollectionScroll($('.ls-main-collection-bottom-model .ls-featured-collection-sliderbox'), 6);
              // 监听集合底部Recently Viewed模块曝光
              var dom = document.querySelector('.ls-main-collection-bottom-model .box-recently-viewed');
              LS.ui.globalModelShowHandle(dom, LS.ui.collectionReportMap['showRecentlyViewedCollection'], {ext2: JSON.stringify(reportData || [])});
            }
            // 全局列表曝光方法
            LS.ui.globalListExposureHandle();
          }
        },
        error: function (error) {
          // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
        complete: function() {
        }
      });
    },

    // 动态插入aboutus
    insertAboutUsHander: function () {
      var marketingUrl = 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/20230406-133737_2400x.jpg?v=1680759651';
      var imgUrl = 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/aboutus_en_pc_2400x.jpg?v=1677835152';
      var marketingHtml = '';
      var isShow = false;
      if (isShow && LS.ui.isFunctionOpenCountry()) {
        var bottomModule = $('.ls-main-collection-bottom-model');
        bottomModule.length && bottomModule.hide();
        marketingHtml = `
          <a class="common-bottom_image-wrapper" href="${LS.site.dir}/collections/thats-one-cool-chick">
            <img class="common-bottom_image" src="${marketingUrl}" />
          </a>
        `;
      };
      var aboutUsHtml = `
        <a class="product-about-us-wrapper" href="${LS.site.dir}/pages/about-us">
          <div class="section-looksky-aboutus">
            <img class="aboutus-image" src="${imgUrl}" />
          
            <div class="aboutus-text-image-wrapper">
              <img class="aboutus-text-image" src="${LS.$t('page.about_us.banner_image_pc')}" />
            </div>
          </div>
        </a>
      `;
      var resHtml = marketingHtml + aboutUsHtml;
      // 添加在footer模块前面
      $('#section-looksky-footer').before(resHtml);
    },

  }

  // 初始化方法
  function init() {
    // 上报参数
    reportData = {
      id: $('.looksky-main-collection-modelbox').attr('collectionid'),
      name: $('.looksky-main-collection-modelbox').attr('handle')
    };
    // 事件集合方法
    collectionPageFn.bindEvent();
    setTimeout(function() {
      LS.ui.storeIsRegisteAd();
      // 创建filter内容方法
      collectionPageFn.handleFilterData();
      if (LS.ui.showRegisteModule()) {
        LS.ui.insertRegisteModuel && LS.ui.insertRegisteModuel('collection');
      } else {
        collectionPageFn.createTopModelHandle();
      }
      // 创建集合页底部配置区域
      collectionPageFn.createfooterModelHandle();
      // 动态插入aboutus
      collectionPageFn.insertAboutUsHander();
    }, 500)
  }
  
  init();

  LS.ui.collectionPageFn = {
	};

})();